<template>
  <div class="model-frame">
    <el-row>
      <div class="model-header">
        <h2>Lớp học</h2>
        <el-button @click="createModel" size="small" type="info" class="btn-create">Thêm mới</el-button>
      </div>
    </el-row>
    <el-row>
      <div class="model-filter">
        <el-col :span="4">
          <el-select v-model="filter.status" filterable clearable placeholder="Trạng thái" class="input-select" @change="ChangedStatus">
            <el-option
              v-for="item in lists.listStatus"
              :key="item.key"
              :label="item.value"
              :value="item.key">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="2">
          <el-popover
            placement="bottom"
            title="Sắp xếp theo"
            width="400"
            trigger="click"
            content="Nội dung">
            <div class="model-filter-radio"
              v-for="(item, index) in sort"
              :key="index">
              <span>{{ item.groupName }}:</span>
              <el-radio
                v-for="(itemSort, index_itemSort) in item.groupFiled"
                :key="index_itemSort"
                v-model="filter.sort" :label="itemSort.label">{{ itemSort.text }}</el-radio>
            </div>
            <span class="model-filter-search" slot="reference">
              <i class="fas fa-sort"></i>
            </span>
          </el-popover>
        </el-col>
        <el-col :span="12"></el-col>
        <el-col :span="5">
          <el-input
            placeholder="Tìm kiếm ..."
            class="input-seach"
            clearable
            :prefix-icon="searching ? 'fas fa-spinner fa-spin' : 'el-icon-search'"
            v-model="filter.q">
          </el-input>
        </el-col>
      </div>
    </el-row>
    <el-row :gutter="10">
      <div class="model-filter">
        <el-col :span="5">
          <el-select v-model="filter.school_id" filterable clearable placeholder="Chọn trường" class="input-select" @change="changedSchool">
            <el-option
              v-for="item in lists.listSchool"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-select v-model="filter.level_id" filterable clearable placeholder="Chọn phân hệ" class="input-select" @change="changedLevel">
            <el-option
              v-for="item in lists.listLevel"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="5">
          <el-select v-model="filter.facult_id" filterable clearable placeholder="Chọn chuyên ngành" class="input-select" @change="changedFacult">
            <el-option
              v-for="item in lists.listFacult"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="5">
          <el-select v-model="filter.user_id" filterable clearable placeholder="Chọn giảng viên" class="input-select" @change="changedUser">
            <el-option
              v-for="item in lists.listTeacher"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="5"></el-col>
      </div>
    </el-row>
    <el-row>
      <div class="model-pagination">
          <el-pagination
            background
            layout="prev, pager, next"
            :page-size="table.pagination.per_page"
            :pager-count="table.pagination.count"
            :current-page="table.pagination.current_page"
            :total="table.pagination.total"
            @current-change="changeCurrentPage">
          </el-pagination>
          <div style="padding-left: 5px">
            Hiển thị tới Lớp học <strong>{{ table.meta_pagination }}</strong> / Tổng số: <strong>{{ table.pagination.total }}</strong> Lớp học
          </div>
      </div>
    </el-row>
    <el-row>
      <div class="model-table">
        <el-table
          v-loading="loading"
          border
          :data="table.database"
          style="width: 100%">
          <el-table-column
            label="#"
            type="index"
            width="40">
          </el-table-column>
          <el-table-column
            prop="name"
            label="Mã lớp"
            width="220">
            <template slot-scope="scope">
              <div class="courses-info">
                <strong style="color: green">{{ scope.row.code }}</strong>
                <span>Ngày tạo: {{ scope.row.created_at }}</span>
                <span>Cập nhật: {{ scope.row.updated_at }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="Thông tin">
            <template slot-scope="scope">
              <div class="courses-info">
                <span v-if="scope.row.school_id">
                  <strong>Trường: </strong>
                  {{ scope.row.school_text }}
                </span>
                <span v-if="scope.row.level_id">
                  <strong>Phân hệ: </strong>
                  {{ scope.row.level_text }}
                </span>
                <span v-if="scope.row.facult_id">
                  <strong>Chuyên ngành: </strong>
                  {{ scope.row.facult_text }}
                </span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="Môn học">
            <template slot-scope="scope">
              <div class="courses-info">
                <span>Tổng số môn học: {{ scope.row.count_course_current }}</span>
                <span>Tổng số kì: {{ scope.row.count_term_current }}</span>
                <span>Tổng số học viên: {{ scope.row.count_user_current }}</span>
                <span>GV chủ nhiệm: {{ scope.row.teachter_text }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            width="120"
            label="Trạng thái">
            <template slot-scope="scope">
              <div v-if="scope.row.status" class="item_active">
                <i class="fas fa-circle"></i>
                <span>{{ scope.row.status_txt }}</span>
              </div>
              <div v-else class="item_not_active">
                <i class="fas fa-circle"></i>
                <span>{{ scope.row.status_txt }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="Kích hoạt"
            width="80"
            align="center">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.status"
                active-color="#13ce66"
                inactive-color="#7f8c8d"
                @change="changeStatus(scope.row)">
              </el-switch>
            </template>
          </el-table-column>

          <el-table-column
            label="Đóng lớp"
            width="80"
            align="center">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.is_close"
                active-color="#13ce66"
                inactive-color="#7f8c8d"
                @change="changeCloseStatus(scope.row)">
              </el-switch>
            </template>
          </el-table-column>

          <el-table-column
            label="Hành động"
            width="180"
            header-align="center">
            <template slot-scope="scope">
              <div class="module-action">
                <!-- <el-tooltip effect="dark" content="Xem" placement="top">
                  <span @click="showModel(scope.row)">
                    <i class="fas fa-search icon-search"></i>
                  </span>
                </el-tooltip> -->
                <el-tooltip effect="dark" content="Xem bảng điểm" placement="top">
                  <span @click="showScore(scope.row)">
                    <i class="fas fa-list-ul"></i>
                  </span>
                </el-tooltip>
                <el-tooltip effect="dark" content="Sửa" placement="top">
                  <span @click="updateModel(scope.row)">
                    <i class="far fa-edit icon-update"></i>
                  </span>
                </el-tooltip>
                <el-tooltip effect="dark" content="Xóa" placement="top">
                  <span @click="confirmDeleteModel(scope.row)">
                    <i class="far fa-trash-alt icon-delete"></i>
                  </span>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import { head, findIndex } from 'lodash'
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'Promotions',
  metaInfo () {
    return {
      title: 'Lớp học'
    }
  },
  data () {
    return {
      loading: false,
      searching: false,
      filter: {
        q: '',
        status: '',
        daterange: '',
        school_id: '',
        level_id: '',
        facult_id: '',
        specialized_id: '',
        user_id: '',
        page: 1,
        limit: 15,
        sorted: '',
        include: ''
      },
      sort: [
        {
          groupName: 'Không sắp xếp',
          groupFiled: [
            { label: '', text: 'Không sắp xếp' }
          ]
        },
        {
          groupName: 'Tên',
          groupFiled: [
            { label: 'name:-1', text: 'Tăng dần' },
            { label: 'name:1', text: 'Giảm dần' }
          ]
        }
      ],
      lists: {
        listStatus: [
          {key: 1, value: 'Kích hoạt'},
          {key: 0, value: 'Chưa kích hoạt'}
        ],
        listCategoryBlogs: [
          {key: 1, value: 'Menu chính'},
          {key: 2, value: 'Footer cột Giới thiệu'},
          {key: 3, value: 'Footer cột Cộng tác viên Affiliate'},
          {key: 4, value: 'Footer cột Chính sách'}
        ],
        listSchool: [],
        listLevel: [],
        listFacult: [],
        listSpecialized: [],
        listKey: [],
        listTeacher: []
      },
      table: {
        database: [],
        meta_pagination: 0,
        pagination: {
          total: 0,
          count: 0,
          per_page: 0,
          current_page: 1,
          total_pages: 0
        },
        timer: {}
      }
    }
  },
  created() {
  },
  computed: {
    ...mapGetters('classPros', ['getSearchClassProStatus',
      'getSearchClassProSchool',
      'getSearchClassProLevel',
      'getSearchClassProFacult',
      'getSearchClassProUser']),
  },
  mounted () {
    this.configBreadcrumb()
    this.fetchDatabaseModel()
    this.fetchSchool()
  },
  methods: {
    ...mapActions(['setBreadcrumb']),
    ...mapActions('classPros', ['changeSearchClassProStatus',
      'changeSearchClassProSchool',
      'changeSearchClassProLevel',
      'changeSearchClassProFacult',
      'changeSearchClassProUser']),
    ChangedStatus (payload) {
      this.changeSearchClassProStatus(payload)
    },
    changedSchool (payload) {
      this.changeSearchClassProSchool(payload)
    },
    changedLevel (payload) {
      this.changeSearchClassProLevel(payload)
    },
    changedFacult (payload) {
      this.changeSearchClassProFacult(payload)
    },
    changedUser (payload) {
      this.changeSearchClassProUser(payload)
    },
    // Cấu hình Breadcrumb
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'class-pros-index', text: 'Lớp học' }
      ]
      this.setBreadcrumb(breadcrumb)
    },
    // Nút tạo Model
    createModel () {
      this.$router.push({name: 'class-pros-create'})
    },
    // Fetch dữ liệu
    fetchDatabaseModel () {
      this.loading = true

      this.filter.status = this.getSearchClassProStatus
      this.filter.school_id = this.getSearchClassProSchool
      this.filter.level_id = this.getSearchClassProLevel
      this.filter.facult_id = this.getSearchClassProFacult
      this.filter.user_id = this.getSearchClassProUser

      axios.get('class-pros', {params: this.filter}).then(response => {
        this.loading = false
        switch (response.code) {
          case 200:
            this.table.database = response.data
            this.table.pagination = response.meta.pagination
            this.caculaterMetaPagination()
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xẳy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    fetchSchool () {
      axios.get('schools', {params: {'status': 1, 'limit': -1}}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listSchool = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    fetchLevel () {
      let data = {
        'status': 1,
        'limit': -1,
        'school_id': this.filter.school_id
      }
      axios.get('levels', {params: data}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listLevel = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    fetchFacult () {
      let data = {
        'status': 1,
        'limit': -1,
        'school_id': this.filter.school_id,
        'level_id': this.filter.level_id
      }
      axios.get('facults', {params: data}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listFacult = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    fetchSpecialized () {
      let data = {
        'status': 1,
        'limit': -1,
        'school_id': this.filter.school_id,
        'level_id': this.filter.level_id,
        'facult_id': this.filter.facult_id
      }
      axios.get('specializeds', {params: data}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listSpecialized = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    fetchListTeacher () {
      let data = {
        'status': 1,
        'limit': -1,
        'user_type': 2,
        'school_id': this.filter.school_id
      }
      axios.get('users', {params: data}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listTeacher = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Tính trường số bản ghi xem nó đang hiện đến bao nhiêu
    caculaterMetaPagination () {
      if (this.table.pagination.current_page === this.table.pagination.total_pages) {
        this.table.meta_pagination = (this.table.pagination.current_page - 1) * this.table.pagination.per_page + this.table.pagination.count
      } else {
        this.table.meta_pagination = this.table.pagination.current_page * this.table.pagination.per_page
      }
    },
    // Xem chi tiết
    showModel (model) {
      // let routeData = this.$router.resolve({name: 'class-pros-show', params: {id: model.id}})
      // window.open(routeData.href, '_blank')
      this.$router.push({name: 'class-pros-show', params: {id: model.id}})
    },
    // Xem bảng điểm
    showScore (model) {
      // let routeData = this.$router.resolve({name: 'class-pros-show', params: {id: model.id}})
      // window.open(routeData.href, '_blank')
      this.$router.push({name: 'class-pros-show-list-user', params: {id: model.id}})
    },
    updateModel (model) {
      // let routeData = this.$router.resolve({name: 'class-pros-update', params: {id: model.id}})
      // window.open(routeData.href, '_blank')
      this.$router.push({name: 'class-pros-update', params: {id: model.id}})
    },
    // Đổi trạng thái kích hoạt / không kích hoạt
    changeStatus (model) {
      let dataUpdate = {
        'status': model.status
      }
      axios.post('class-pros/update-status/' + model.id, dataUpdate).then(response => {
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Cập nhật trạng thái thành công',
              type: 'success',
              duration: '2000'
            })
            model.status_txt = model.status ? 'Kích hoạt' : 'Chưa kích hoạt'
            break
          default:
            this.fetchDatabaseModel()
            break
        }
      })
    },
    // Đổi trạng thái đóng/mở lớp
    changeCloseStatus (model) {
      let dataUpdate = {
        'is_close': model.is_close
      }
      axios.post('class-pros/update-close-status/' + model.id, dataUpdate).then(response => {
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Cập nhật trạng thái thành công',
              type: 'success',
              duration: '2000'
            })
            break
          default:
            this.fetchDatabaseModel()
            break
        }
      })
    },
    // confirmDeleteModel
    confirmDeleteModel (model) {
      this.$confirm('Xác nhận xóa lớp: ' + model.code + '-Chuyên ngành ' + model.facult_text, 'Warning', {
        confirmButtonText: 'Đồng ý',
        cancelButtonText: 'Hủy',
        type: 'warning'
      }).then(() => {
        this.deleteModel(model)
      }).catch(() => {

      })
    },
    // Xóa bản ghi
    deleteModel (model) {
      axios.delete('class-pros/' + model.id).then(response => {
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Xóa bản ghi thành công',
              type: 'success'
            })
            let indexDelete = this.findIDLocal(model)
            if (indexDelete > -1) {
              this.table.database.splice(indexDelete, 1)
            }
            break
          case 404:
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: 'Không tìm thấy tài nguyên',
              type: 'warning'
            })
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Tìm ID ở database Local để xóa đi
    findIDLocal (model) {
      let index = findIndex(this.table.database, function (o) {
        return o.id === model.id
      })
      return index
    },
    // Thay đổi Current Page
    changeCurrentPage (currentPage) {
      this.filter.page = currentPage
      this.fetchDatabaseModel()
    }
  },
  watch: {
    'filter.status': function () {
      this.fetchDatabaseModel()
    },
    'filter.q': function () {
      this.searching = true
      clearTimeout(this.timer)
      let _this = this
      this.timer = setTimeout(function () {
        _this.searching = false
        _this.fetchDatabaseModel()
      }, 800)
    },
    'filter.sort': function () {
      this.fetchDatabaseModel()
    },
    'filter.school_id': function () {
      this.filter.level_id = ''
      this.filter.facult_id = ''
      this.filter.specialized_id = ''
      this.filter.user_id = ''

      this.lists.listLevel = []
      this.lists.listFacult = []
      this.lists.listSpecialized = []
      this.lists.listTeacher = []

      if (this.filter.school_id) {
        this.fetchLevel()
        this.fetchListTeacher()
      }

      this.fetchDatabaseModel()
    },
    'filter.level_id': function () {
      this.filter.facult_id = ''
      this.filter.specialized_id = ''

      this.lists.listFacult = []
      this.lists.listSpecialized = []

      if (this.filter.level_id) {
        this.fetchFacult()
      }

      this.fetchDatabaseModel()
    },
    'filter.facult_id': function () {
      this.filter.specialized_id = ''

      this.lists.listSpecialized = []

      if (this.filter.facult_id) {
        this.fetchSpecialized()
      }

      this.fetchDatabaseModel()
    },
    'filter.specialized_id': function () {
      this.fetchDatabaseModel()
    },
    'filter.user_id': function () {
      this.fetchDatabaseModel()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.model-filter-search {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #efefef;
  border-radius: 2px;
  width: 30px;
  height: 30px;
  cursor: pointer;
}
.model-filter-radio {
  margin-bottom: 10px;
}
.model-filter-radio span {
  margin-right: 20px;
  width: 135px;
  display: inline-block;
}
.course-image {
  width: 150px;
  border-radius: 2px;
}
.courses-info {
  display: flex;
  flex-direction: column;
}
.courses-info span {
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/class-pros/Index.vue